import { useTranslation } from "react-i18next";
import Group from "assets/images/group.png";
import "./index.scss";
import { removeAccessTokenCookie, removeRefreshTokenCookie } from "lib/Storage";
import useInputKeys from "hooks/useInputKeys";

const Profile = () => {
  const { t } = useTranslation();
  const { userInfo } = useInputKeys();

  const handleLogout = () => {
    console.log("logout");
    removeRefreshTokenCookie();
    removeAccessTokenCookie();
    window.location.reload();
  };

  return (
    <div className="profile-component-wrapper">
      <div className="parent-box-shadow">
        <div className="box-shadow">{userInfo?.cardName}</div>
        <div className="box-shadow box-phone-number">
          <div>phone number</div>
          <div className="phone-number">{userInfo?.phoneNumber}</div>
        </div>
        <div className="box-shadow" onClick={handleLogout} style={{cursor: 'pointer'}}>
          {t("logout")}
        </div>
      </div>

      <div className="box-avatar">
        {userInfo?.hasAvatar ? (
              <img
                src={`https://fs.zharfabeen.com/onacademyp/${
                  userInfo.username
                }`}
                alt=""
              />
            ) : (
              <img src={Group} alt=""/>
            )}
      </div>
    </div>
  );
};

export default Profile;
